import * as conf from '@/config';

export function getUrlPath(url?: string) {
  // if has sub path, such as '/subpath/${url}'
  return url ?? '';
  /*
  if (url && url !== '') {
    if (url.indexOf('http') > -1) {
      return url;
    }
    return `${conf.API_RESOURCE_URL}${url}`;
  }
  return '';
  */
}

export function getUrlFilePath(url?: string) {
  if (url && url !== '') {
    if (url.indexOf('http') > -1) {
      return url;
    }
    if (url.indexOf(':/') > -1) {
      // local file
      // ex: file:///G:/BlueProject/BlueOcean/bs-prisma-api/public/avatars/avatar-holder-2024-10-14T18-59-36.webp
      return `file:///${url}`;
    }
    if (url.indexOf('blob:') > -1) {
      return url;
    }
    return `${conf.API_RESOURCE_URL}${url}`;
  }
  return '';
}

export function getUrlImagePath(url?: string) {
  if (url && url !== '') {
    if (url.indexOf('http') > -1) {
      return url;
    }
    if (url.indexOf(':/') > -1) {
      // local file
      // ex: file:///G:/BlueProject/BlueOcean/bs-prisma-api/public/avatars/avatar-holder-2024-10-14T18-59-36.webp
      return `file:///${url}`;
    }
    if (url.indexOf('blob:') > -1) {
      return url;
    }
    return `${conf.API_RESOURCE_URL}${url}`;
  }
  return '';
}

export function getUrlAvatarPath(url?: string) {
  if (url && url !== '') {
    if (url.indexOf('http') > -1) {
      return url;
    }
    if (url.indexOf(':/') > -1) {
      // local file
      // ex: file:///G:/BlueProject/BlueOcean/bs-prisma-api/public/avatars/avatar-holder-2024-10-14T18-59-36.webp
      return `file:///${url}`;
    }
    if (url.indexOf('blob:') > -1) {
      return url;
    }
    return `${conf.API_RESOURCE_URL}${url}`;
  }
  return '';
}

export function getUrlAPI(url: string) {
  // if has sub path, such as '/subpath/${url}'
  return url;
}
